module.exports = __webpack_public_path__ + "assets/img/vtuber-banner.2c62b8da.png";